module.exports = __webpack_public_path__ + "img/map.a4971fd7.svg";